import { ToastPosition } from 'react-toastify'
import moment from 'moment'
import { environment } from '../environments/environment'

class Helper {
  static toCamelCase = (name: string = '') => {
    return (
      name !== '' &&
      name?.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.slice(1)
      })
    )
  }
  static checkSouceDeatils = (source_details = [] as any) => {
    if (source_details?.length > 0) {
      return source_details.some((srcDetails: any) =>
        srcDetails?.length > 0 && ['EPIC', 'ELATION'].includes(srcDetails[0]?.toUpperCase())
      )
    }
  }

  static toCamelCaseFirstWord = (str: string = '') => {
    return str && str?.length > 0 ? str.charAt(0).toUpperCase() + str.slice(1) : str
  }

  static isPrgInActive = (program_enrollments: any, prg: any) => {
    if (prg?.length < 1) return false
    const inactivePrg = program_enrollments
      ?.map((i: any) => {
        if (i.status === 'inactive') return i.program
      })
      ?.filter((i: any) => i !== undefined)
    return prg?.length === 1 ? inactivePrg?.includes(prg[0]) : prg?.every((p: any) => inactivePrg.includes(p))
  }

  static toCamelCaseObject = (data: any) => {
    if (data !== '' && data !== undefined) {
      if (typeof data !== 'string') return data
      const nameObj = data.split(',')
      return nameObj?.map((i: any) => Helper.toCamelCase(i))
    }
  }

  static toCamelCaseRole = (currentRole: any) => {
    if (currentRole !== '' && currentRole !== undefined) {
      const userRole = currentRole?.split(',')?.find((i: any) => ['PROVIDER', 'NAVIGATOR'].includes(i))
      return userRole !== '' && userRole !== undefined ? Helper.toCamelCase(userRole) : ''
    }
  }

  static toLowerlCase = (name: string = '') => {
    return name.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toLowerCase() + txt.substr(1)
    })
  }

  static stageName = (str: string = '') => {
    if (!str) return ''
    return str.charAt(0).toUpperCase() + str.slice(1).toLocaleLowerCase().replaceAll('_', ' ')
  }

  static getError = (error: any) => {
    const msg = (
      error?.response?.data?.error?.message ||
      error?.response?.data?.error ||
      error?.response?.data?.message ||
      error?.response?.data ||
      error?.payload?.response?.data?.error?.message ||
      error?.payload?.message ||
      error?.response?.data?.error ||
      error?.error?.message ||
      'Unknown Error'
    )
    // Check for elation_source specific errors and provide user-friendly message
    if (typeof msg === 'string' && (msg.includes('elation_source is required') || msg.includes('has no elation_source set'))) {
      return 'This patient needs to be associated with an Elation instance. Please re-sync the patient with the correct source.'
    }
    return msg
  }

  static getErrorText = (payload: any) => {
    const msg = payload?.response?.data?.error?.message || payload?.message || 'Unknown Error'
    // Check for elation_source specific errors and provide user-friendly message
    if (typeof msg === 'string' && (msg.includes('elation_source is required') || msg.includes('has no elation_source set'))) {
      return <div>This patient needs to be associated with an Elation instance. Please re-sync the patient with the correct source.</div>
    }
    const formattedContent = msg.replace(/\n/g, '<br />')
    return <div dangerouslySetInnerHTML={{ __html: formattedContent }} />
  }

  static isElationSourceError = (error: any): boolean => {
    const msg = error?.response?.data?.error?.message || ''
    return typeof msg === 'string' && (msg.includes('elation_source is required') || msg.includes('has no elation_source set'))
  }

  static bottom_center = () => {
    return {
      position: 'bottom-center' as ToastPosition,
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
    }
  }

  static top_center = () => {
    return {
      position: 'top-center' as ToastPosition,
      autoClose: 6000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
    }
  }

  static dateChecking = (input: string = '') => {
    const temp = input.split(' on ')
    if (temp.length > 1 && moment(temp[1], 'DD MMM YYYY hh:mm A').isValid()) {
      return `${temp[0]} on ${moment(temp[1], 'DD MMM YYYY hh:mm A').utc(true).local().format('DD MMM, YYYY hh:mm A')}`
    }
    return input
  }

  static throttle = (fn: any, delay: number | undefined) => {
    let run = false
    return function (...args: any) {
      if (!run) {
        fn(...args)
        run = true
        setTimeout(() => (run = false), delay)
      }
    }
  }

  static checkGroup = (group: any, currentRole: any) => {
    if (group !== '' && group !== undefined && typeof group === 'string') group = group?.split(',')
    if (currentRole !== '' && currentRole !== undefined && typeof currentRole === 'string') currentRole = currentRole?.split(',')
    return group?.some((i: any) => currentRole?.indexOf(i) >= 0)
  }

  static getRXnorm = (name: any, rxnorm: any) => (name && rxnorm && rxnorm !== 'none' && rxnorm !== undefined ? `${name} [${rxnorm}]` : name)

  static handleReportFile = (data: any, name: string) => {
    const link = document.createElement('a')
    link.href = window.URL.createObjectURL(new Blob([data]))
    link.setAttribute('download', `${name}_${moment().unix()}.csv`)
    document.body.appendChild(link)
    link.click()
  }

  static handleTaskReportFile = (data: any, name: string) => {
    const link = document.createElement('a')
    link.href = window.URL.createObjectURL(new Blob([data]))
    link.setAttribute('download', name)
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(link.href)
  }

  static handleDashboardReportFile = (data: any, name: string) => {
    const link = document.createElement('a')
    link.href = window.URL.createObjectURL(new Blob([data]))
    if (name === 'Tasks_and_Events_Report') {
      let date = moment(moment.now()).format('YYYY-MM-DD')
      link.setAttribute('download', `${name}_${date}.xlsx`)
    } else {
      let date = moment.tz(moment(), 'America/New_York').format('YYYY-MM-DD')
      link.setAttribute('download', `${name}_${date}_morning_combined.xlsx`)
    }
    document.body.appendChild(link)
    link.click()
  }
  static handleReportZipFile = (data: any, name: string) => {
    const link = document.createElement('a')
    const blob = new Blob([data], { type: 'application/zip' })
    link.href = URL.createObjectURL(blob)
    link.setAttribute('download', `${name}.zip`)
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(link.href)
  }
  static getUTCDate = (date?: any) => {
    return moment(date ? date : moment.now()).format('YYYY-MM-DD')
  }
  static isEvaluationPrg = (program_enrollments = [] as any) => {
    return program_enrollments.some((m: any) => m.program_type === 'evaluation' && m.selected)
  }
  static isAmyloidPrg = (program_enrollments = [] as any) => {
    return program_enrollments.some((m: any) => m.program === 'amyloidosis_evaluation' && m.selected)
  }
  static isTreatmentPrg = (program_enrollments = [] as any) => {
    return program_enrollments.some((m: any) => m.program_type !== 'evaluation' && m.selected)
  }
  static isOIDC = () => {
    return environment.oidc.isEnabled
  }
  static isAIDA = () => {
    return environment.aida.isEnabled
  }
  static isAIDAPrg = (program_enrollments = [] as any) => {
    return Object.keys(program_enrollments)?.length > 0 ? environment.aida.isEnabled && Helper.isEvaluationPrg(program_enrollments) : environment.aida.isEnabled
  }
  static is_AIDA_OIDC = () => {
    return environment.aida.isEnabled || environment.oidc.isEnabled
  }
  static updateDiagnosisGroup = (latestObj: any, diaObj: any = [], recObj: any = []) => {
    // Find if calculator exists in recommended or data arrays
    const isInRecommended = recObj.some((calc: any) => calc.questionnaire_id === latestObj.questionnaire_id)
    const isInData = diaObj.some((calc: any) => calc.questionnaire_id === latestObj.questionnaire_id)

    // Find current calculator with programs data
    let currCal = recObj.find((el: any) => el.questionnaire_id === latestObj.questionnaire_id)
    if (!currCal?.programs) {
      currCal = diaObj.find((el: any) => el.questionnaire_id === latestObj.questionnaire_id)
    }

    // Guard clause: if currCal is not found, return both arrays unchanged
    if (!currCal) {
      console.warn(`${latestObj.display_name} not found`)
      return {
        calculators: diaObj,
        recommended_calculators: recObj,
      }
    }

    // Create updated calculator object with corrected first_component_type
    const updatedObj = {
      ...latestObj,
      programs: currCal.programs,
      first_component_type: currCal.first_component_type, // Use from currCal, not latestObj
      mode: 'view',
    }

    // Parse response value using the CORRECT component type from currCal
    const responseValue =
      updatedObj.first_response !== null && updatedObj.first_response !== undefined
        ? currCal.first_component_type === 'scale'
          ? parseFloat(updatedObj.first_response)
          : updatedObj.first_response
        : null

    const isScaleType = currCal.first_component_type === 'scale'
    const isScaleNeutral = isScaleType && responseValue === 3

    // Remove from both arrays initially
    let newData = diaObj?.filter((item: any) => item.questionnaire_id !== latestObj.questionnaire_id)
    let newRecommendedData = recObj?.filter((item: any) => item.questionnaire_id !== latestObj.questionnaire_id)

    // Determine where the (updatedObj) item should go based on response
    if (isInRecommended && (isScaleNeutral || (!isScaleType && responseValue === null))) {
      // Keep/move to recommended if neutral or no response
      newRecommendedData = [...newRecommendedData, updatedObj]
    } else {
      // Move to calculators if there's a definitive response (Yes/No or scale >3 or <3)
      newData = [...newData, updatedObj]
    }

    return {
      calculators: newData,
      recommended_calculators: newRecommendedData,
    }
  }
}

export default Helper
